/**
 * Configuracao compartilhada para estoque Bling
 * Gerencia quais depositos devem ser considerados como "principal"
 */

const STORAGE_KEY = 'bling_main_deposit_ids';
export const BLING_HIDDEN_DEPOSIT_IDS = [14886506404];

function toNumericId(value) {
    const parsed = Number.parseInt(String(value || ''), 10);
    return Number.isFinite(parsed) ? parsed : null;
}

function isHiddenDeposit(warehouse) {
    const warehouseId = toNumericId(warehouse?.id ?? warehouse?.reference_id);
    return Number.isFinite(warehouseId) && BLING_HIDDEN_DEPOSIT_IDS.includes(warehouseId);
}

/**
 * Carrega IDs de depositos principais do localStorage
 * @returns {Array<number>} Array de IDs de depositos
 */
export const LoadMainDepositIds = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            return Array.isArray(parsed) && parsed.length > 0 ? parsed : [13772186008];
        }
    } catch (err) {
        console.error('Erro ao carregar depositos do localStorage:', err);
    }
    return [13772186008]; // Default: deposito principal
};

/**
 * Salva IDs de depositos principais no localStorage
 * @param {Array<number>} ids - Array de IDs de depositos
 */
export const SaveMainDepositIds = (ids) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (err) {
        console.error('Erro ao salvar depositos no localStorage:', err);
    }
};

/**
 * Filtra estoque Bling para retornar apenas dos depositos principais
 * @param {Object} stockInfo - Dados de estoque do Bling (com warehouses)
 * @param {Array<number>} mainDepositIds - IDs dos depositos principais
 * @returns {Object} Dados de estoque filtrados
 */
export const FilterMainDepositStock = (stockInfo, mainDepositIds) => {
    if (!stockInfo || !stockInfo.warehouses) {
        return stockInfo;
    }

    const visibleWarehouses = stockInfo.warehouses.filter((warehouse) => !isHiddenDeposit(warehouse));

    // Filtrar apenas depositos principais (sempre removendo depositos ocultos)
    const mainWarehouses = visibleWarehouses.filter((warehouse) => {
        const warehouseId = toNumericId(warehouse?.id ?? warehouse?.reference_id);
        return Number.isFinite(warehouseId) && mainDepositIds.includes(warehouseId);
    });

    // Calcular quantidade total apenas dos depositos principais
    const mainQuantity = mainWarehouses.reduce((sum, w) => sum + (w.quantity || 0), 0);
    const visibleQuantity = visibleWarehouses.reduce((sum, w) => sum + (w.quantity || 0), 0);

    return {
        ...stockInfo,
        quantity: mainQuantity,
        total_visible_quantity: visibleQuantity,
        warehouses: visibleWarehouses,
        mainWarehouses: mainWarehouses, // Depositos principais separados
    };
};

/**
 * Filtra um Map de estoques Bling para retornar apenas dos depositos principais
 * @param {Map} stockMap - Map de SKU -> dados de estoque
 * @param {Array<number>} mainDepositIds - IDs dos depositos principais
 * @returns {Map} Map filtrado
 */
export const FilterMainDepositStockMap = (stockMap, mainDepositIds) => {
    if (!stockMap || stockMap.size === 0) {
        return stockMap;
    }

    const filteredMap = new Map();
    stockMap.forEach((stockInfo, sku) => {
        filteredMap.set(sku, FilterMainDepositStock(stockInfo, mainDepositIds));
    });

    return filteredMap;
};
